var map = {
	"./baidu.svg": "cvyf",
	"./bilibili.svg": "cACO",
	"./bing.svg": "fwuD",
	"./gitee.svg": "WGZz",
	"./github.svg": "z6R7",
	"./google.svg": "YgBy",
	"./sjx.svg": "Ypz/",
	"./sougou.svg": "qe2Q",
	"./stackoverflow.svg": "60RO",
	"./toutiao.svg": "Gezy",
	"./zhihu.svg": "3wYi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 40